/**
 * Rẽ MỤC GIỜ CÔNG của bản kê lương theo phòng ban.
 *
 * Để riêng ở tệp không có giao diện vì hai mục dùng chung nó nằm ở hai tệp
 * (`CrewHoursDetail` bên `WorkBreakdownDetail.tsx`, `ReceptionDetail` bên
 * `ReceptionDetail.tsx`), mà xuất hàm thường từ tệp có component thì lint
 * `react-refresh` chặn. Đặt cạnh nhau cũng đúng chỗ hơn: sửa một rào là thấy
 * ngay rào kia, tránh cảnh một phòng lọt vào hai mục hoặc rơi khỏi cả hai.
 */

/**
 * Thợ chụp / thợ trang điểm — giờ có mặt và tăng ca (QĐ 0105) dùng CÙNG hai ô
 * hoursWorked / overtimeHours với lễ tân, nên phải rẽ theo phòng: không rẽ là
 * giờ của thợ chui vào mục "Lễ tân".
 */
export function isCrewDept(dept: string | undefined): boolean {
  return !!dept && (dept.startsWith("photo") || dept === "makeup");
}

/**
 * Phòng có MỤC GIỜ CÔNG RIÊNG trên bản kê — không được rơi vào mục "Lễ tân".
 *
 * `ReceptionDetail` vẽ cho mọi phòng không phải thợ, miễn là bản ghi có giờ.
 * Đó là cái rào đủ dùng khi chỉ lễ tân trả theo giờ. Từ QĐ 0164 có thêm Trợ lý
 * Studio cũng trả theo giờ, và họ là PHÒNG KHÁC với mục riêng.
 */
export function hasOwnHoursSection(dept: string | undefined): boolean {
  return isCrewDept(dept) || dept === "studio_assistant";
}
